import styled from "styled-components";
import { LinksBox } from "../DefaultModal/style";

export const Links = styled(LinksBox)`
  justify-content: flex-end;
`;
